import { HomeComponent } from './home/home.component';
import { AvailabilitiesComponent } from './availabilities/availabilities.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DescriptionComponent } from './description/description.component';
import { PricesComponent } from './prices/prices.component';
import { PicturesComponent } from './pictures/pictures.component';
import { DiscoverComponent } from './discover/discover.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { DiscoverPlaceComponent } from './discover/discover-place/discover-place.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { LinksComponent } from './links/links.component';
import { NewsComponent } from './news/news.component';
import { UsefullAddressesComponent } from './usefull-addresses/usefull-addresses.component';
import { ContactComponent } from './contact/contact.component';
import { LoginComponent } from './login/login.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'availabilities', component: AvailabilitiesComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'description', component: DescriptionComponent },
  { path: 'discover', component: DiscoverComponent },
  { path: 'discover/:id', component: DiscoverPlaceComponent },
  { path: 'equipment', component: EquipmentComponent },
  { path: 'home', component: HomeComponent },
  { path: 'links', component: LinksComponent },
  { path: 'login', component: LoginComponent },
  { path: 'news', component: NewsComponent },
  { path: 'prices', component: PricesComponent },
  { path: 'pictures', redirectTo: 'pictures/40000000-0000-0000-0000-000000000001', pathMatch: 'full' },
  { path: 'pictures/:id', component: PicturesComponent },
  { path: 'reviews', component: ReviewsComponent },
  { path: 'usefull-addresses', component: UsefullAddressesComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
